import cx from 'classnames';

import { Button } from '../form/button/Button';
import { Typography } from '../typography/Typography';

import style from './OperationalDestinationBanner.module.css';

type Props = {
    title: string;
    message: string;
    pillLabel?: string | null;
    ctaLabel?: string | null;
    ctaUrl?: string | null;
    className?: string;
};

export function OperationalDestinationBanner({
    title,
    message,
    pillLabel,
    ctaLabel,
    ctaUrl,
    className,
}: Props) {
    return (
        <div role="alert" className={cx(style.banner, className)}>
            <div className={style.content}>
                {pillLabel ? (
                    <Typography scale="primary-xs-bold" className={style.pill}>
                        <span aria-hidden="true" className={style.pillDot} />
                        <span>{pillLabel}</span>
                    </Typography>
                ) : null}

                <Typography as="p" scale="primary-s-extra-bold" className={style.title}>
                    {title}
                </Typography>

                <Typography as="p" scale="primary-body-regular" className={style.message}>
                    {message}
                </Typography>
            </div>

            {ctaLabel && ctaUrl ? (
                <div className={style.cta}>
                    <Button priority="primary" href={ctaUrl}>
                        {ctaLabel}
                    </Button>
                </div>
            ) : null}
        </div>
    );
}
